import { storage } from './storage.js';
import { uid } from './utils.js';

/* Espectadores: personas dentro de una cuenta (como los perfiles de Netflix). Cada uno tiene su
   Mi lista, su progreso, sus canales recientes y, si es infantil, el control parental fijo.
   Los proveedores IPTV se comparten entre todos los espectadores de la cuenta. */

export const MAX_VIEWERS = 5;
export const AVATAR_COLORS = ['#e50914', '#1f8ef1', '#2ecc71', '#f5a623', '#9b59b6', '#e67e22', '#1abc9c', '#ff5e8a'];

export function avatarColor(viewer) {
    return AVATAR_COLORS[(Number(viewer && viewer.avatar) || 0) % AVATAR_COLORS.length];
}

export function avatarInitial(viewer) {
    const name = String((viewer && viewer.name) || '').trim();
    return name ? name[0].toUpperCase() : '?';
}

export const viewers = {
    /** Cuenta remota (account.js) que replica altas, cambios y bajas en el servidor. */
    remote: null,

    list() {
        return storage.get('viewers', []) || [];
    },

    save(list) {
        storage.set('viewers', list);
    },

    get(id) {
        return this.list().find((v) => v.id === id) || null;
    },

    current() {
        return this.get(storage.get('viewerId')) || null;
    },

    setCurrent(id) {
        storage.set('viewerId', id);
    },

    /** Garantiza al menos un espectador (nombre de pila del usuario o "Yo"). */
    ensureDefault(name) {
        const list = this.list();
        if (list.length) return list[0];
        const viewer = { id: uid(), name: String(name || '').trim().split(/\s+/)[0] || 'Yo', avatar: 0, kids: false, createdAt: Date.now() };
        this.save([viewer]);
        return viewer;
    },

    async add(data) {
        const list = this.list();
        if (list.length >= MAX_VIEWERS) throw new Error('limit');
        let viewer = Object.assign({ id: uid(), name: '', avatar: list.length % AVATAR_COLORS.length, kids: false, maxAge: null, createdAt: Date.now() }, data);
        viewer.name = String(viewer.name || '').trim().slice(0, 30);
        if (!viewer.name) throw new Error('invalid_name');
        if (this.remote) viewer = Object.assign(viewer, await this.remote.upsertViewer(viewer));
        list.push(viewer);
        this.save(list);
        return viewer;
    },

    async update(id, data) {
        const list = this.list();
        const idx = list.findIndex((v) => v.id === id);
        if (idx === -1) return null;
        list[idx] = Object.assign({}, list[idx], data);
        list[idx].name = String(list[idx].name || '').trim().slice(0, 30);
        if (!list[idx].name) throw new Error('invalid_name');
        if (this.remote) list[idx] = Object.assign(list[idx], await this.remote.upsertViewer(list[idx]));
        this.save(list);
        return list[idx];
    },

    async remove(id) {
        if (this.list().length <= 1) return false;
        if (this.remote) await this.remote.removeViewer(id);
        const list = this.list().filter((v) => v.id !== id);
        this.save(list);
        if (storage.get('viewerId') === id) storage.remove('viewerId');
        return true;
    }
};
